import { NavigationRow } from "@/components/layout/Navigation";
import { Machine } from "@/services/model/machine";
import { Translates } from "@/services/repository/i18n";
import { CurrentSession } from "@/services/repository/session";
import { Roles } from "@/services/repository/users";

export function MachinePath({translates, machine, session}: {translates: Translates, machine: Machine, session?: CurrentSession}): NavigationRow[] {
  return [{
    path: session?.user.role === Roles.SuperAdmin ? `/superadmin/machines` : undefined, //`/communal/machine/${machine.id}`
    title: translates.for('page.communal-machine-dashboard.title')
  }, {
    path: `/communal/machine/${machine.id}`,
    title: machine.internalNumber || machine.id
  }]
}